<template>
  <div class="main">
    <span class="">
      <div v-if="!readOnly" class="op">
        <span>
          <label>{{ $t('selecione-uma-operacao-1') }} </label>
          <b-form-select
            class="input-pentagro"
            v-model="operationSelected"
            :options="operations"
          ></b-form-select>
        </span>
        <b-icon 
          v-if="operationSelected"
          :class="{
            'ml-2': true,
            'ferm-button' : true,
            'btn-icon': true,
            'btn-success': !currentCreated,
            'btn-secondary': currentCreated,
          }"
          :title="$t('criar-correntes-internas')"
          icon="link" 
          @click="createInnerCurrents" 
          aria-hidden="true" />
      </div>
      <b-form class="b-layout node-oppened" @submit.prevent="">
        <b-card v-if="equipments.length > 0">
          <p class="ptitulos1">{{ $t('centrifugas-da-fermentacao-equipamentos') }}</p>
          <div v-for="(prop, index) in equipments" :key="prop.caption + index">
            <b-form-checkbox
                  class="switch-item"
                  v-model="prop.value"
                  @change="ChangeOnOff($event, prop)"
                  switch
                  >
                  {{ prop.equipName }}
            </b-form-checkbox>
          </div>
        </b-card>
        <b-modal id="descriptionsBatch" ok-only>
          <p>
            {{ $t('teste') }}
          </p>
          <p>
            {{ $t('teste2') }}
          </p>
          <p>
            {{ $t('teste3') }}
          </p>
        </b-modal>
        <div v-if="operationSelected" class="varieables">
          <b-nav class="tab" tabs>
            <b-nav-item class="ferm-tab properties" @click="changeTab" active>{{ $t('properties') }}</b-nav-item>
            <b-nav-item class="ferm-tab time-fermentation" @click="changeTab" >{{ $t('tempo-de-fermentacao') }}</b-nav-item>
          </b-nav>
          <b-card :class="{ 'card-variable': true, readOnly: node.readOnly }">
            <div v-if="!tabVisible">
              <p class="ptitulos1">
                {{ $t('tempos-da-fermentacao') }} </p>
              <div class="inp">
                <label>{{ $t('numero-de-dornas') }} </label>
                <input
                  min="0"
                  @change="calc()"
                  v-model="nD.value"
                  type="number"
                />
              </div>

              <div class="inp">
                <label>{{ $t('dornas-em-enchimento') }} </label>
                <input
                  min="0"
                  @change="calc()"
                  v-model="nDE.value"
                  type="number"
                />
              </div>

              <div class="inp">
                <label>{{ $t('temperatura-de-fermentacao-oc') }} </label>
                <input min="0" v-model="Tf.value" type="number" />
              </div>
              <div class="inp">
                <div>
                  <label>{{ $t('tempo-de-carga-h') }} </label>
                  <b-icon font-scale="0.9" class="question-icon" icon="question-circle-fill" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('tempo-volume-inicial-fermento-adicionado-dorna'), }"></b-icon>
                </div>
                <input
                  min="0"
                  @change="calc()"
                  v-model.number="tcg.value"
                  type="number"
                  step="0.1"
                />
              </div>

              <div class="inp">
                <div>
                  <label>{{ $t('tempo-de-limpeza-h') }} </label>
                  <b-icon font-scale="0.9" class="question-icon" icon="question-circle-fill" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('tempo-assepsia-dorna') , }"></b-icon>
                </div>
                <input
                  min="0"
                  @change="calc()"
                  v-model.number="tl.value"
                  type="number"
                  step="0.1"
                />
              </div>

              <div class="inp">
                <div>
                  <label>{{ $t('tempo-de-fermentacao-h') }} </label>
                  <b-icon font-scale="0.9" class="question-icon" icon="question-circle-fill" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('tempo-fermentacao-enchimento-mosto-espera-reacao') , }"></b-icon>
                </div>
                <input min="0" @change="calc()" v-model="tf.value" type="number" />
              </div>

              <div class="inp">
                <div>
                  <label>{{ $t('tempo-de-espera-h') }} </label>
                  <b-icon font-scale="0.9" class="question-icon" icon="question-circle-fill" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('tempo-reacao-continua-ocorrer-apos-adicao-mosto'), }"></b-icon>
                </div>
                <p>{{ this.Espera.value | ParseNumber }}</p>
              </div>

              <div class="inp">
                <div>
                  <label>{{ $t('tempo-de-enchimento-h') }} </label>
                  <b-icon font-scale="0.9" class="question-icon" icon="question-circle-fill" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('tempo-mosto-ser-alimentado-dorna'), }"></b-icon>
                </div>
                <p>{{ this.te.value | ParseNumber }}</p>
              </div>

              <div class="inp">
                <div>
                  <label>{{ $t('tempo-de-centrifugacao-h') }} </label>
                  <b-icon font-scale="0.9" class="question-icon" icon="question-circle-fill" v-b-popover.hover="{ variant: 'secondary',  content:$t('tempo-centrifugacao-vinho'), }"></b-icon>
                </div>
                <p>{{ this.Centrifugacao.value | ParseNumber }}</p>
              </div>

              <div class="inp">
                <div>
                  <label>{{ $t('tempo-de-ciclo-h') }} </label>
                  <b-icon class="question-icon" font-scale="0.9" icon="question-circle-fill" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('tempo-total-carga-enchimento-espera-centrtifugacao-limpeza'), }"></b-icon>
                </div>
                <p>{{ this.tcc.value | ParseNumber }}</p>
              </div>

            </div>
            <div v-else-if="tabVisible == 1">
              <p class="ptitulos">{{ $t('centrifugas-da-fermentacao-formularios') }}</p>

              <div class="inp">
                <label>{{ $t('levedura-no-vinho-centrifugado') }} </label>
                <input min="0" v-model="TR.value" type="number" />
              </div>

              <div class="inp">
                <label>{{ $t('levedura-no-creme') }} </label>
                <input min="0" v-model="f_C.value" type="number" />
              </div>

              <div v-if="Rendimento" class="inp">
                <label>{{ $t('rendimento-global-da-fermentacao') }} </label>
                <p>{{ this.Rendimento.value | ParseNumber }}</p>
              </div>

              <div class="inp">
                <label>{{ $t('capacidade-instalada-ton-h') }} </label>
                <p>{{ this.Capacidade.value | ParseNumber }}</p>
              </div>

              <div class="inp">
                <label>{{ $t('ocupacao-1') }} </label>
                <p>{{ this.Ocupacao.value | ParseNumber }}</p>
              </div>

              <hr />
              <p class="ptitulos">{{ $t('cuba-0') }}</p>

              <div class="inp">
                <label>{{ $t('fracao-massica-de-celulas-na-alimentacao-0') }}</label>
                <input min="0" v-model="X.value" type="number" />
              </div>

              <div class="inp">
                <label>{{ $t('taxa-de-reciclo') }} </label>
                <input min="0" v-model="P_FT.value" type="number" />
              </div>

            </div>
          </b-card>
        </div>
      </b-form>
    </span>
    <div v-if="jokerEquipmentList.length" :class="{joker: true, readOnly: node.readOnly }">
      <label class="mt-2 ml-2">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2">
            <TextToInput
              :text="joker.caption"
              @sendText="updateCaption($event, joker)"
            >
            </TextToInput>
          </div>
          <span class="b-layout">
            <b-card v-if="equipments.length > 0">
              <div
                v-for="(prop, index) in joker.equipments"
                :key="prop.caption + index"
              >
                <b-form-checkbox
                  class="switch-item"
                  v-model="prop.value"
                  @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                  switch
                  >
                  {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div class="inp mb-2">
                  <label>{{ $t('capacidade-instalada-ton-h-0') }} </label>
                  <label v-if="joker.capacidade" class="input-data">{{
                    joker.capacidade.value | ParseNumber
                  }}</label>
                </div>
                <div class="inp">
                  <label>{{ $t('ocupacao-0') }} </label>
                  <label class="input-data">{{
                    joker.Ocupacao.value | ParseNumber
                  }}</label>
                </div>
              </b-card>
            </div>
          </span>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { NumberFormat, ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from "../../../mixins/jokerEquipmentsMixin";
import TextToInput from "../../../template/TextToInput";
import { ControllerFermentationBatch } from "./controllerFermentationBatch";
import { FiltersMixin } from "../../../mixins/filtersMixin";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  components: { TextToInput },
  mixins: [JokerEquipmentMixin, FiltersMixin],

  data() {
    return {
      tcg: {},
      tl: {},
      tf: {},
      nD: {},
      nDE: {},
      tcc: {},
      Espera: {},
      te: {},
      Centrifugacao: {},
      Tf: {},
      TR: {},
      f_C: {},
      P_FT: {},
      X: {},
      Yps: {},
      Rendimento: {},
      Capacidade: {},
      Ocupacao: {},
      operations: [
        { value: null, text:this.$t('selecione-uma-fermentacao-batelada')  },
      ],
      equipments: [],
      equipCap: [],
      operationSelected: null,
      operationAttributeList: [],
      attributesList:this.$t('selecione-uma-fermentacao-batelada'),
      firstLoad: false,
      currentCreated: false,
      attrList: [
        "tcg",
        "tl",
        "tf",
        "nD",
        "nDE",
        "tcc",
        "te",
        "Tf",
        "TR",
        "f_C",
        "P_FT",
        "X",
        "Yps",
        "Rendimento",
        "Ocupacao",
        "Capacidade",
      ],
      tabVisible: 1
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();
      this.buildJokerEquipment(value);
      this.jokerEquipmentList.forEach((joker) => {
        joker.equipments = joker.equipments.filter((e) =>
          e.equipName.match(/Centrifuga/)
        );
      });

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attr) => {
        this[attr] = this.operationAttributeList.find((p) => attr == p.caption);
        if (this[attr]) this[attr].value = ParseToNumber(this[attr].value);
      });

      this.calc();
      this.updateNode();
    },

    "tcg.value"() {
      this.updateNode();
    },

    "tl.value"() {
      this.updateNode();
    },

    "tf.value"() {
      this.updateNode();
    },

    "nD.value"() {
      this.updateNode();
    },

    "nDE.value"() {
      this.updateNode();
    },

    "Tf.value"() {
      this.updateNode();
    },

    "TR.value"() {
      this.updateNode();
    },

    "f_C.value"() {
      this.updateNode();
    },

    "P_FT.value"() {
      this.updateNode();
    },

    "X.value"() {
      this.updateNode();
    },

    "Yps.value"() {
      this.updateNode();
    },

    "te.value"() {
      this.updateNode();
    },

    "tcc.value"() {
      this.updateNode();
    },
  },

  methods: {

    batchDescription() {
      //$bvModal.show('descriptionsBatch')
    },

    calc() {
      let nD = ParseToNumber(NumberFormat(this.nD.value));
      let nDE = ParseToNumber(NumberFormat(this.nDE.value));
      let tcc = ParseToNumber(NumberFormat(this.tcc.value));
      let tl = ParseToNumber(NumberFormat(this.tl.value));
      let tcg = ParseToNumber(NumberFormat(this.tcg.value));
      let tf = ParseToNumber(NumberFormat(this.tf.value));

      tcc = tcg + tl + tl + tcg + tf

      this.Espera.value = ((nD - nDE) * (tcc / nD) - (tl + tcg + tcg + tl)).toString();
      this.tcc.value = tcc;
      this.Centrifugacao.value = (tcg + tl).toString();
      this.te.value = tf - this.Espera.value;
    },

    loadNode() {
      if (this.node.data[0] && this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.firstLoad = true;
        this.buildJokerEquipment(
          this.node.data[0].index,
          this.node.jokerCaption
        );
        
        this.jokerEquipmentList.forEach((joker) => {
          joker.equipments = joker.equipments.filter((e) =>
            e.equipName.match(/Centrifuga/)
          );
        });

        this.loadNotInput();
        this.loadEquipments(); 
      }

      this.node.data.forEach((p) => {
        this.attrList.forEach((a) => {
          if (p.key == a && !p.equipName) {
            p.value = ParseToNumber(p.value);
            this[a] = p;
          }
        });

        if (p.equipName != "") {
          let equipToUpdate = this.equipments.find(e => e.equipName === p.equipName);
          if (equipToUpdate) {
            equipToUpdate.value = parseInt(p.value) ? true : false;
          }
        }
      });

      this.calc();
      this.Changecapacidade();
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Quantidade") {
            console.log('props[p] :>> ', props[p].value, props[p]);
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            if (props[p].strValue != "") {
              props[p].value = props[p].strValue;
            }
            this.equipCap.push(props[p]);
          }
        });
      });
      this.equipments = auxEquipment;
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.Changecapacidade();
      this.switchStatusJoker(
        prop,
        this.equipments,
        false,
        this.Changecapacidade
      );
      this.updateNode();
    },

    Changecapacidade() {
      console.log('this.Capacidade :>> ', this.Capacidade);
      if (this.Capacidade.value) {
        this.Capacidade.value = 0;
        this.equipments.forEach((e) => {
          let capFerm = this.equipCap.find((c) => c.equipName == e.equipName);
          if (e.value && capFerm)
            this.Capacidade.value += parseFloat(
              String(capFerm.value).replace(",", ".")
            );
        });
      }
    },

    updateNode() {
      if (this.firstLoad) return;

      let attrs = [
        this.tcg.clone(),
        this.tcc.clone(),
        this.te.clone(),
        this.tl.clone(),
        this.tf.clone(),
        this.nD.clone(),
        this.nDE.clone(),
        this.Tf.clone(),
        this.TR.clone(),
        this.f_C.clone(),
        this.P_FT.clone(),
        this.X.clone(),
        this.Yps.clone(),

        this.Capacidade.clone(),
        this.Ocupacao.clone(),
      ];

      if (this.Rendimento && this.Rendimento.clone) {
          attrs.push(this.Rendimento.clone());
      }

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? "1,00" : "0,00";
        attrs.push(prop);
      });

      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList);
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/Fermentacao/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = ["Capacidade", "Ocupacao", "tcc", "te", "Rendimento"];

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.key
        );

        if (attrName == "Capacidade")
          this.Capacidade.value =
            this.equipments.length > 0
              ? ParseToNumber(this.Capacidade.value)
              : "";
        if (attrName == "Ocupacao")
          this.Ocupacao.value = isNaN(parseFloat(this.Ocupacao.value))
            ? ""
            : ParseToNumber(this.Ocupacao.value);
        
        if (attrName == "Rendimento" && this.Rendimento)
          this.Rendimento.value = isNaN(parseFloat(this.Rendimento.value))
            ? ""
            : ParseToNumber(this.Rendimento.value);
      });
    },

    createInnerCurrents() {
      if(this.currentCreated) return
      this.currentCreated = true;
      let ctr = new ControllerFermentationBatch();
      ctr.createCurrents(
        this.node.x + this.node.width + 50,
        this.node.y,
        this.node.attrs[0].index
      );
    },

    changeTab(event){
        document.querySelectorAll(".ferm-tab>a").forEach(el => el.classList.remove('active'))
        
        let result = event.target.innerText;

        if(result == "Propriedades"){
          this.tabVisible = 1
          document.querySelector(".properties>a").classList.add('active')
        }
        else if(result == "Tempo de Fermentação"){
          this.tabVisible = 0
          document.querySelector(".time-fermentation>a").classList.add('active')
        }
      },
  },

  mounted() {
    this.loadOperation();
    setTimeout(this.loadNode(), 200);
    this.changeExternalCapacity = function () {
      this.Changecapacidade();
    };
    this.updataNodeInMixin = function () {
      this.updateNode();
    };
  },
};
</script>

<style scoped>
form {
  padding: 12px 10px;
  color: #0009;
}

.main {
  height: 53vh;
  display: flex;
}

.main-config,
.joker {
  width: 480px;
  height: 40vh;
  overflow-y: auto;
}

.b-layout {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.b-layout.node-oppened {
  min-width: 870px;
}

.card-variable{
  margin: 0px 5px;
  width: 515px;
  overflow-y: auto;
}

.joker,
.card-variable{
  height: 40vh;
}

.readOnly{
  height: 48vh;
}

.tab{
  margin: 5px 5px 0px 7px;
}

.tab a{
  color: #0007;
  background-color: #00000008;
  height: 25px;
  padding: 2px 8px 22px 8px;
}

input,
p {
  margin: 0px;
  text-align: right;
}

.inp {
  margin: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.op {
  margin: 5px 8px 2px 8px;
  display: flex;
  align-items: flex-end;
}

.op label{
  margin: 0;
}

.op select{
  height: 25px;
  padding: 0px 8px;
}

.ferm-button{
  height: 25px;
  border-radius: 5px;
  color: #fff;
  width: 33px;
  padding: 0px 5px;
  cursor: pointer;
}

.ptitulos {
  text-align: left;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}
.ptitulos1 {
  text-align: left;
  font-weight: bold;
  margin-bottom: 10px;
}

.question-icon{
  color: #ff5f00;
  cursor: help;
  margin: 0px 10px 5px 4px;
}
</style>